const POST_BOOKING_URL_ENDPOINT = 'postBookingURL';
const logger = require('od-modules/utils/logger');
const fetcher = require('od-modules/utils/fetcher');

const validateParams = (params) => {
    const requiredParams = ['bookingId', 'email', 'buyPath'];
    for (const param of requiredParams) {
        if (!params[param]) {
            throw new Error(`Missing ${param}`);
        }
    }
};

module.exports = {

    /**
     * Performs a request with the provided parameters to retrieve the accommodation postbooking url
     *
     * @param {Object} params - An object containing the parameters for the request.
     * @param {number} params.bookingId - The booking ID.
     * @param {string} params.email - The email address.
     * @param {string} params.buyPath - The buyPath
     * @return {Promise<string>} A string with the accomomdation postbooking deeplink
     * @throws {Error} If the request is not successful.
     */
    get: async(params) => {
        validateParams(params);

        let result;
        const baseUrl = `${Odigeo.Settings.getProperty('appContext')}/service/${POST_BOOKING_URL_ENDPOINT}`;
        const queryString = Object.keys(params).map((key) => `${encodeURIComponent(key)}=${encodeURIComponent(params[key])}`).join('&');
        try {
            result = await fetcher.get(`${baseUrl}?${queryString}`).json();
            return result.url;
        } catch (error) {
            await logger.error(error, 'Error getting accommodation postbooking url: ', error);
            throw error;
        }
    },
};

